/* Nubello - carousels and accordions.
   Re-runs on shopify:section:load so it works inside the theme editor. */
(function(){
  'use strict';

  function initCarousel(root){
    if(root.dataset.nbInit) return;
    var track = root.querySelector('[data-nb-track]');
    var prev  = root.querySelector('[data-nb-prev]');
    var next  = root.querySelector('[data-nb-next]');
    var dots  = root.querySelector('[data-nb-dots]');
    var sel   = root.getAttribute('data-nb-item') || '[data-nb-slide]';
    /* data-nb-loop: arrows never dead-end - past the last card goes back to
       the first, and back from the first goes to the last. Opt-in, so every
       carousel that does not ask for it behaves exactly as before. */
    var loop  = root.hasAttribute('data-nb-loop');
    if(!track || !prev || !next) return;
    root.dataset.nbInit = '1';

    function items(){ return Array.prototype.slice.call(track.querySelectorAll(sel)); }

    function nearest(){
      var cards = items(), x = track.scrollLeft, best = 0, bestD = Infinity;
      cards.forEach(function(c,i){
        var d = Math.abs((c.offsetLeft - track.offsetLeft) - x);
        if(d < bestD){ bestD = d; best = i; }
      });
      return best;
    }

    function sync(){
      var max = track.scrollWidth - track.clientWidth;
      var scrollable = max > 1;
      prev.disabled = !scrollable || (!loop && track.scrollLeft <= 1);
      next.disabled = !scrollable || (!loop && track.scrollLeft >= max - 1);
      if(dots){
        var at = nearest();
        Array.prototype.slice.call(dots.children).forEach(function(d,i){
          d.setAttribute('aria-current', i === at ? 'true' : 'false');
        });
      }
    }

    /* scroll to a card's own offset rather than by a delta: with snapping in
       play a relative scrollBy gets re-targeted and can skip a card */
    function show(i){
      var cards = items();
      if(!cards.length) return;
      i = Math.max(0, Math.min(cards.length - 1, i));
      var target = cards[i].offsetLeft - track.offsetLeft;
      if(track.scrollTo) track.scrollTo({ left: target, behavior: 'smooth' });
      else track.scrollLeft = target;
      sync();
    }

    if(dots){
      dots.innerHTML = '';
      items().forEach(function(_, i){
        var b = document.createElement('button');
        b.type = 'button';
        b.setAttribute('aria-label', 'Go to item ' + (i + 1));
        b.addEventListener('click', function(){ show(i); });
        dots.appendChild(b);
      });
    }

    /* the end is judged by scroll position, not by card index: the last card
       can be fully on screen while an earlier one is still "nearest" */
    function atStart(){ return track.scrollLeft <= 1; }
    function atEnd(){ return track.scrollLeft >= track.scrollWidth - track.clientWidth - 1; }
    prev.addEventListener('click', function(){
      if(loop && atStart()) show(items().length - 1);
      else show(nearest() - 1);
    });
    next.addEventListener('click', function(){
      if(loop && atEnd()) show(0);
      else show(nearest() + 1);
    });
    track.addEventListener('scroll', sync);
    window.addEventListener('resize', sync);
    sync();
  }

  function initAccordion(root){
    if(root.dataset.nbInit) return;
    root.dataset.nbInit = '1';
    root.querySelectorAll('[data-nb-acc-btn]').forEach(function(btn){
      btn.addEventListener('click', function(){
        var open = btn.getAttribute('aria-expanded') === 'true';
        var panel = btn.nextElementSibling;
        btn.setAttribute('aria-expanded', open ? 'false' : 'true');
        if(panel) panel.classList.toggle('nb-open', !open);
      });
    });
  }

  function boot(scope){
    var root = scope || document;
    root.querySelectorAll('[data-nb-carousel]').forEach(initCarousel);
    root.querySelectorAll('[data-nb-acc]').forEach(initAccordion);
  }

  /* A CTA linking to the page you are already on - the footer's "Shop the
     collar" when you are on the collar page - scrolls to the bundle picker
     instead of reloading the page at the top. On any other page the link is
     followed as normal. Delegated and registered once: this file is included
     by every Nubello section. */
  if(!window.nbPickerLinks){
    window.nbPickerLinks = true;
    document.addEventListener('click', function(e){
      var a = e.target.closest && e.target.closest('a.nb-btn[href]');
      if(!a || e.defaultPrevented || e.button || e.metaKey || e.ctrlKey || e.shiftKey) return;
      var url;
      try { url = new URL(a.getAttribute('href'), window.location.href); } catch(err){ return; }
      if(url.origin !== window.location.origin || url.pathname !== window.location.pathname || url.hash) return;
      var picker = document.querySelector('.nb-hero .nb-bundles');
      if(!picker) return;
      e.preventDefault();
      window.scrollTo({ top: picker.getBoundingClientRect().top + window.pageYOffset - 90, behavior: 'smooth' });
    });
  }

  if(document.readyState === 'loading'){
    document.addEventListener('DOMContentLoaded', function(){ boot(); });
  } else {
    boot();
  }
  document.addEventListener('shopify:section:load', function(e){ boot(e.target); });
})();
